// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"070c3341","605":"eda06ef4","809":"62452d41","981":"2ef1b317"}[chunkId] + ".chunk.js";
};